enum PriceCalculatorResultStatusEnum {
  Pending = 'pending',
  Preview = 'preview',
  Success = 'success',
  Error = 'error'
}

export default PriceCalculatorResultStatusEnum
